import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap CSS
import './App.css';
import React, { useState, useEffect } from "react";

import { BrowserRouter as Router } from 'react-router-dom';
import AppRouter from './router';

import { faAlignLeft, faUser, faSignOutAlt } from "@fortawesome/free-solid-svg-icons";
import { Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { resetAuthData } from "./stores/modules/idp/authreducer";
import { resetCapSelfAssessmentData } from "./stores/modules/cap/selfassessmentreducer";
import { refreshToken } from "services/modules/idp/auth";
import { useSelector } from 'react-redux';
import { library } from "@fortawesome/fontawesome-svg-core";
import RoleDescriptionPage from './components/RoleDescriptionPage.jsx';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';

library.add(faAlignLeft, faUser, faSignOutAlt);

function App() {
  const dispatch = useDispatch();
  const authenticationDetails = useSelector(state => state.auth.authenticationDetails);
  const authenticationStatus = useSelector(state => state.auth.authenticationStatus);
  const authenticateduser = useSelector(state => state.auth.user);
  const [showLogoutConfirmation, setShowLogoutConfirmation] = useState(false);
  const [showCount, setShowCount] = useState(30);
  const [loggeduser, setloggeduser] = useState(null);
  let timeoutId;
  let countdown = 30;
  let countdownInterval;
  const [tokenRefreshTimeoutId, setTokenRefreshTimeoutId] = useState(null); // Initialize tokenRefreshTimeoutId

  useEffect(() => {
    resetTimeout();

    const handleActivity = () => {
      resetTimeout();
    };

    window.addEventListener("mousemove", handleActivity);
    window.addEventListener("keydown", handleActivity);
    window.addEventListener("scroll", handleActivity);

    return () => {
      window.removeEventListener("mousemove", handleActivity);
      window.removeEventListener("keydown", handleActivity);
      window.removeEventListener("scroll", handleActivity);
      clearTimeout(timeoutId);
    };
   // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (authenticationStatus === true) {
      showRoleDetails();
      resetTokenRefreshTimeout();
    } else {
      clearInterval(tokenRefreshTimeoutId); // Clear interval when authenticationStatus is false
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticationStatus]);

  const resetTimeout = () => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      showDialoglogout();
    }, 300000); // 5 minutes in milliseconds
  };

  const resetTokenRefreshTimeout = () => {
    if (authenticationStatus) {
      clearInterval(tokenRefreshTimeoutId);
      setTokenRefreshTimeoutId(setInterval(() => {
        let params = {
          "refreshtoken": authenticationDetails.refresh_token
        };
        dispatch(refreshToken({ params }));
      }, 1200000)); // 20 minutes in milliseconds
    }
  };

  const showDialoglogout = async () => {
    if (authenticationStatus) {
      startCountdown();
      setShowLogoutConfirmation(true);
    } else {
      setShowLogoutConfirmation(false);
      resetCountdown();
    }
  };

  const handleCloseConfirmation = () => {
    setShowLogoutConfirmation(false);
    resetCountdown();
    resetTimeout();
  };

  const startCountdown = () => {
    clearInterval(countdownInterval);
    countdown = 30;
    setShowCount(countdown);
    countdownInterval = setInterval(() => {
      if (countdown <= 0) {
        handleLogout();
        clearInterval(countdownInterval);
        countdown = 30;
        setShowCount(countdown);
      }
      countdown--;
      setShowCount(countdown);
    }, 1000);
  };

  const resetCountdown = () => {
    clearInterval(countdownInterval);
    countdown = 30;
    setShowCount(countdown);
  };

  const handleLogout = () => {
    dispatch(resetAuthData());
    dispatch(resetCapSelfAssessmentData());
    setShowLogoutConfirmation(false);
    
    resetCountdown();
    resetTimeout();
    window.location.href = "/login";
  };

  const showRoleDetails = () => {
    setTimeout(() => {
      let loggeduser = authenticateduser.roles[0].slug;
      setloggeduser(loggeduser);
    }, 1000);
  };

  return (
    <div>
      <Router>
        <AppRouter />
      </Router>

      <Dialog
        onClose={handleCloseConfirmation}
        open={showLogoutConfirmation}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          <div className="text-h4">Logout Confirmation.</div>
        </DialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom>
            <div className='audit-trail-popuptext'>
              <div className="m-2">
                Are you sure you want to logout due to inactivity?
              </div>
              <div className="m-2 px-lg">Auto logout in {showCount} seconds. </div>
              <div className="m-4" style={{ width: '100%', justifyContent: 'space-between' }}>
                <Button className="approve-button" onClick={handleCloseConfirmation}>
                  Cancel
                </Button>
                <Button className='reject-button' onClick={handleLogout}>
                  Logout
                </Button>
              </div>
            </div>
          </Typography>
        </DialogContent>
      </Dialog>

      {loggeduser !== '' && (
        <RoleDescriptionPage />
      )}

    </div>
  );
}

export default App;
